
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-wellness-articles/[slug]",
      function () {
        return require("private-next-pages/health-wellness-articles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-wellness-articles/[slug]"])
      });
    }
  